import { createSlice } from '@reduxjs/toolkit';

const notificationStatusSlice = createSlice({
    name: 'notificationStatus',
    initialState: {
        notificationCount: 0,
    },
    reducers: {
        setNotificationCount(state, action) {
            state.notificationCount = action.payload;
        },
        clearNotificationCount(state) {
            state.notificationCount = 0;
        },
    },
});

export const { setNotificationCount, clearNotificationCount } = notificationStatusSlice.actions;

export default notificationStatusSlice.reducer;
